export interface IForgotUsernameResponse {
    data: {
        success: boolean,
        message: string
    }
};